import { transformCurrencyAmountDtoOrString } from './currency-amount';
export const transformOfferDto = _ref => {
  let {
    id,
    price,
    currency
  } = _ref;
  return {
    id,
    price: transformCurrencyAmountDtoOrString(price, currency)
  };
};